import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { Box, Button, Stack } from "@mui/joy";
import { LinkOptions } from "@tanstack/react-router";
import { ApiLeague, ApiLeagueSummary } from "griptonite-api-client";
import { ReactNode } from "react";

import { ButtonLink } from "../Links";

const BottomButtons = ({
  league,
  nextLink,
  prevLink,
  formState,
  isFinalStep,
}: {
  league?: ApiLeague | ApiLeagueSummary;
  nextLink?: LinkOptions;
  prevLink?: LinkOptions;
  formState?: { isSubmitting: boolean; isDirty: boolean };
  isFinalStep?: boolean;
}) => {
  const isCreatingComp = !league;
  const isWizardMode =
    isCreatingComp || ("competitions" in league && league.competitions.length === 0);

  let nextButton: ReactNode = null;
  if (formState?.isDirty || (formState && (!isWizardMode || !nextLink))) {
    nextButton = (
      <Button
        type="submit"
        size="lg"
        color="primary"
        loading={formState.isSubmitting}
        loadingPosition="start"
        endDecorator={isWizardMode && !isFinalStep ? <KeyboardArrowRight /> : null}
        disabled={!formState.isDirty}
      >
        {isWizardMode && !isFinalStep ? "Save and Continue" : "Save"}
      </Button>
    );
  } else if (nextLink && isWizardMode) {
    nextButton = (
      <ButtonLink
        replace
        size="lg"
        color="primary"
        endDecorator={<KeyboardArrowRight />}
        {...nextLink}
      >
        Continue
      </ButtonLink>
    );
  }

  return (
    <Stack direction="row" alignItems="center">
      {prevLink && isWizardMode ? (
        <ButtonLink
          replace
          size="lg"
          color="neutral"
          startDecorator={<KeyboardArrowLeft />}
          {...prevLink}
        >
          Back
        </ButtonLink>
      ) : null}
      <Box sx={{ flex: 1 }} />
      {nextButton}
    </Stack>
  );
};

export default BottomButtons;
